<div class="bg-gradient">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-12 col-lg-4">
			
				
				<!-- Login form -->
				<form [formGroup]="loginForm">
					<div class="logo d-flex justify-content-center">
						<img src="assets/images/logo-light.svg" alt="logo-atalaya-light">
					</div>
	
					<ng-container *ngIf="!userAccess">
						<h3>{{'LOGIN.title' | translate}}</h3>
						<div class="form-group">
							<onwac-input 
							[type]="'email'" 
							[label]="'FORMS.fields.email' | translate"
							[input_name]="'username'"
							[submitted]="submitted"
							[parentForm]="loginForm"
							[validators_feedback]="[
								{name : 'required', value : 'FORMS.validators.required' | translate },
								{name : 'email', value : 'FORMS.validators.email' | translate }
							]"></onwac-input>
						</div>
						
						<div class="form-group">
							<onwac-input 
							[type]="'password'" 
							[label]="'FORMS.fields.password' | translate"
							[input_name]="'password'"
							[submitted]="submitted"
							[parentForm]="loginForm"
							[validators]="passwordValidator"
							[validators_feedback]="[
								{name : 'required', value : 'FORMS.validators.required' | translate },
								{name : 'minlength', value : 'FORMS.validators.PasswordMinLength' | translate:{'x':'7'} }
							]"></onwac-input>
						</div>
		
						<div class="form-group">
							<p class="small">{{'LOGIN.forgotPassword' | translate}} <a [routerLink]="['/remember-password']">{{'LOGIN.restore' | translate}}</a></p>
						</div>
		
						<div *ngIf="loginError" class="w-100 text-center error-text">{{'LOGIN.invalidCredentials' | translate}}</div>
		
						<div class="form-group submit">
							<onwac-button [text]="'LOGIN.enter' | translate" [size]="'large'" [extra_clases]="'block'" class="w-100" (click)="onSubmit()"></onwac-button>
						</div>
					</ng-container>
					
					<!-- Access form -->
					<ng-container *ngIf="userAccess && parsedUserAccess">
						<ng-container *ngIf="userAccess.length > 0">
							<h3>{{'LOGIN.access.title' | translate}}</h3>
							<div class="form-group">
								<onwac-input 
								[type]="'select'" 
								[select_items]="parsedUserAccess" 
								[label]="'LOGIN.access.fields.select' | translate" 
								[input_name]="'select_access'" 
								[submitted]="submitted" 
								[parentForm]="loginForm"
								(onChangeSelect)="setUserAccess($event.key)"></onwac-input>
							</div>
			
							<div class="form-group submit">
								<onwac-button [text]="'LOGIN.enter' | translate" [size]="'large'" [extra_clases]="'block'" class="w-100"></onwac-button>
							</div>
						</ng-container>
						<ng-container *ngIf="userAccess.length == 0">
							<p>{{'LOGIN.access.noAccess' | translate}} <a [href]="environment">{{'LOGIN.access.here' | translate}}</a>.</p>
						</ng-container>
					</ng-container>
					<!-- End Access form -->
				</form>
				<!-- End login form -->
	
			</div>
		</div>
	</div>
</div>